import {useTranslation} from 'react-i18next';

import {
    formatIdFilterNames,
    formatSourceList,
    hasSourceFilter,
    isSourceFilterEmpty,
    readSectorFilter,
    readServiceFilter,
    readSources
} from '../../../config/reservationTriggers';
import NodeEditorLayout from '../NodeEditorLayout';
import {NodeEditorV2Props} from '../types';
import ReservationTriggerFilters from './ReservationTriggerFilters';

const ReservationCreatedEditorV2 = ({nodeConfig, setNodeConfig, readOnly}: NodeEditorV2Props) => {
    const {t} = useTranslation();

    const sources = readSources(nodeConfig);
    // From the stored snapshots; an empty filter means any and adds no clause.
    const sectorName = formatIdFilterNames(readSectorFilter(nodeConfig), t);
    const serviceName = formatIdFilterNames(readServiceFilter(nodeConfig), t);

    const noSources = isSourceFilterEmpty(sources);

    const summary = () => {
        if (noSources) return t('No source is ticked, so this trigger never fires.');

        const scope = (() => {
            if (sectorName && serviceName) {
                return t('Runs for every new reservation in {{sector}} booked as {{service}}.', {sector: sectorName, service: serviceName});
            }
            if (sectorName) {
                return t('Runs for every new reservation in {{sector}}, for any service.', {sector: sectorName});
            }
            if (serviceName) {
                return t('Runs for every new reservation booked as {{service}}, in any sector.', {service: serviceName});
            }
            return t('Runs for every new reservation, in any sector and for any service.');
        })();

        const sourceClause = hasSourceFilter(sources)
            ? t('Only reservations from these sources count: {{sources}}.', {sources: formatSourceList(sources!, t)})
            : '';

        const tail = t('The reservation, its dates and the guest profiles on it are available to the steps below.');

        return [scope, sourceClause, tail].filter(Boolean).join(' ');
    };

    return (
        <NodeEditorLayout state={noSources ? 'wontRun' : 'configured'} summary={summary()}>
            <ReservationTriggerFilters
                nodeConfig={nodeConfig}
                setNodeConfig={setNodeConfig}
                readOnly={readOnly}
            />
        </NodeEditorLayout>
    );
};

export default ReservationCreatedEditorV2;
